import ListItem, { type ListItemProps } from '@mui/material/ListItem';
import List, { type ListProps } from '@mui/material/List';
import React from 'react';
import { styled, useThemeProps } from '@mui/material/styles';
import { generateUtilityClasses } from '@mui/material';
import clsx from 'clsx';

export type UnorderedListProps = ListProps;
export type UnorderedListItemProps = ListItemProps;

const unorderedListClassName = 'MuiUnorderedList';
const unorderedListItemClassName = 'MuiUnorderedListItem';
export const unorderedListClasses = generateUtilityClasses(unorderedListClassName, ['root']);
export const unorderedListItemClasses = generateUtilityClasses(unorderedListItemClassName, ['root']);

const UnorderedListThemed = styled(List, {
    name: unorderedListClassName,
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root,
})(() => ({}));

const UnorderedListItemThemed = styled(ListItem, {
    name: unorderedListItemClassName,
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root,
})(() => ({
    // Workaround for some legacy styles
    '::before': { display: 'none' },
}));

export const UnorderedList = React.forwardRef<HTMLUListElement, UnorderedListProps>(function (inProps, ref) {
    const props = useThemeProps({ props: inProps, name: unorderedListClassName });
    return <UnorderedListThemed ref={ref} {...props} className={clsx(props.className, unorderedListClasses.root)} />;
});

UnorderedList.displayName = 'UnorderedList';

export const UnorderedListItem = React.forwardRef<HTMLLIElement, UnorderedListItemProps>(function (inProps, ref) {
    const props = useThemeProps({ props: inProps, name: unorderedListItemClassName });
    return (
        <UnorderedListItemThemed
            ref={ref}
            {...props}
            className={clsx(props.className, unorderedListItemClasses.root)}
        />
    );
});

UnorderedListItem.displayName = 'UnorderedListItem';
